import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const FacilityOfferFinancingStructureSummary = ({ document, t }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <strong>{t('OfferEdit.FinancingStructure.ContractTypeName')}:</strong>{' '}
          <span id={'offerFinancingStructureCard_summary_contractTypeName'}>{document.contractTypeName || ''}</span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <strong>
            {t('OfferEdit.FinancingStructure.Advance')} {t('PERCENT_NUMBER', { number: document.advancePercent || 0 })}%:
          </strong>{' '}
          <span id={'offerFinancingStructureCard_summary_advancePercent'}>
            {document.advance ? `${t('DECIMAL', { number: document.advance })} ${document.currencyCode}` : ''}
          </span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <strong>{t('OfferEdit.FinancingStructure.InterestPercent')}:</strong>{' '}
          <span id={'offerFinancingStructureCard_summary_interestPercent'}>
            {t('PERCENT_NUMBER', { number: document.interestPercent })}%
          </span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <strong>{t('OfferEdit.FinancingStructure.FinancingValue')}</strong>
          <strong>{t('PERCENT_NUMBER', { number: document.financingValuePercent || 0 })}%:</strong>{' '}
          <span id={'offerFinancingStructureCard_summary_financingValuePercent'}>
            {document.financingValue ? `${t('DECIMAL', { number: document.financingValue })} ${document.currencyCode}` : ''}
          </span>
        </Grid>
        {!document.hideInfoForDealersByContractTypes && (
          <Grid item xs={12} sm={6}>
            <strong>{t('OfferEdit.FinancingStructure.ResidualValue')}</strong>
            {document.residualValuePercent != null && document.residualValue != null && (
              <span>
                <strong>({t('PERCENT_NUMBER', { number: document.residualValuePercent || 0 })}%):</strong>{' '}
                <span id={'offerFinancingStructureCard_summary_residualValuePercent'}>
                  {document.residualValue || document.residualValue === 0
                    ? `${t('DECIMAL', { number: document.residualValue })} ${document.currencyCode}`
                    : ''}
                </span>
              </span>
            )}

            {document.residualValuePercent == null && document.residualValue == null && <span>: -</span>}
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <strong>{t('OfferEdit.FinancingStructure.DurationMonths')}:</strong>{' '}
          <span id={'offerFinancingStructureCard_summary_durationMonths'}>{document.durationMonths || ''}</span>
        </Grid>

        {document.logisticTaxExists && (
          <Grid item xs={12} sm={6}>
            <strong>{t('OfferEdit.FinancingStructure.LogisticTax')}:</strong>{' '}
            <span id={'offerFinancingStructureCard_summary_logisticTax'}>
              {document.logisticTax && document.logisticTax.value ? `${t('DECIMAL', { number: document.logisticTax.value })} ` : ''}
            </span>
          </Grid>
        )}
      </Grid>
    </>
  );
};

FacilityOfferFinancingStructureSummary.propTypes = {
  document: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(FacilityOfferFinancingStructureSummary);
